import {connect} from 'react-redux';
import React, {Component} from 'react';

import * as ImageUtils from '../../utils/Image';
import * as ObjectUtils from '../../utils/Property';

class Owner extends Component {
    render() {
        const {userId, firstName, lastName, isShowOriginal, displayName, code, object} = this.props;

        return (
            <div className="rent-owner">
                <div className="rent-owner-person">
                    <div
                        className="rent-owner-avatar"
                        style={{
                            backgroundImage: userId === undefined ?
                                '' :
                                `url(${ImageUtils.getUserAvatarSrc(userId)})`
                        }}
                    />
                    <div className="rent-owner-name">
                        {firstName}&nbsp;{lastName}
                    </div>
                </div>
                <h1 className="rent-owner-title">
                    {isShowOriginal ? displayName : ObjectUtils.getDisplayName(code, object)}
                </h1>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    object: state.objectPage.currentObject,
    code: state.languages.currentLanguage.code,
    isShowOriginal: state.objectPage.isShowOriginal,
    userId: state.objectPage.currentObject.meta.userRepresent.id,
    displayName: state.objectPage.currentObject.description.displayName,
    lastName: state.objectPage.currentObject.meta.userRepresent.lastName,
    firstName: state.objectPage.currentObject.meta.userRepresent.firstName
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Owner);



// WEBPACK FOOTER //
// ./src/components/PropertyPage/Owner.js